import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { StyledEngineProvider } from '@mui/material/styles';

import { useDebounce } from 'use-debounce';
import { VpButton, VpIcon, VpDialogContent } from '../../components';
import { VpDialogTitle } from '../../components/VpDialogTitle';
import { useCreateDownloadPresignedUrl } from '../../../hooks/useDownloadData';
import { VpInput } from '../../inputs';

import styles from './VpMediaDownloadModal.module.less';

const VpMediaDownloadModal = ({ _onClose, isVisible, fileId, fileType, fileData }) => {
  const {
    mutate: generateDownloadUrl,
    isLoading,
    isSuccess,
    isError,
    data: generatedDownloadUrl,
  } = useCreateDownloadPresignedUrl();

  // this is very ugly, but it's a quick way of putting this together
  // unfortunately due to design problems, media & attachments are separate entities,
  // that need completely different treatments.
  // these fallbacks should provide the user with reasonable default names
  const defaultFileName =
    fileData?.attachmentTitle ||
    fileData?.originalFileName?.replace(/\.[^/.]+$/, "") || // regex to cleanup extension
    fileData?.title ||
    fileData?.reviewerName ||
    `${fileData?.campaignName}-${fileData?.uploadDate}`;

  const [fileName, setFileName] = useState(defaultFileName);
  const [isButtonLoading, setIsButtonLoading] = useState(isLoading || !fileId);
  const [debouncedName] = useDebounce(fileName, 1000);
  const [downloadUrl, setDownloadUrl] = useState('');

  const handleFileNameChange = ({ target }) => {
    if (!isButtonLoading) {
      setIsButtonLoading(true);
    }
    const value = target?.value || '';
    setFileName(value);
  };

  const type = fileType === 'VIDEO' ? 'media' : 'attachment';

  useEffect(() => {
    if (fileId) {
      generateDownloadUrl({
        fileId,
        fileType: type,
        name: fileName,
      });
    }
  }, [debouncedName]);

  useEffect(() => {
    if (isSuccess) {
      setDownloadUrl(generatedDownloadUrl);
      setIsButtonLoading(false);
    }
  }, [isSuccess]);

  return (
    <StyledEngineProvider injectFirst>
      <Dialog onClose={() => _onClose()} open={isVisible}>
        <VpDialogTitle
          leftContent={`Download File`}
          onClose={() => _onClose()}
          className={styles.vpModalHeader}
        />
        <VpDialogContent className={styles.vpModalContainer}>
          <VpInput
            label="Choose a name for the file to be downloaded."
            value={fileName}
            onChange={handleFileNameChange}
          />
          <DialogActions className={styles.vpModalActions}>
            <VpButton color="neutral" variant="contained" onClick={_onClose}>
              Cancel
            </VpButton>
            <a href={`${downloadUrl}`} target="_blank">
              <VpButton
                loading={isButtonLoading}
                disabled={isError}
                variant="contained"
                className={styles.vpModalDeleteButton}
                onClick={() => {
                  _onClose();
                }}
                startIcon={<VpIcon icon="Download" />}
              >
                Download
              </VpButton>
            </a>
          </DialogActions>
        </VpDialogContent>
      </Dialog>
    </StyledEngineProvider>
  );
};

export default VpMediaDownloadModal;
VpMediaDownloadModal.displayName = 'VpMediaDownloadModal';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaDownloadModal.jsx